import { CoverageGridCard } from './Card';
import styles from './styles.module.css';

import type { Bundle, Coverage } from '../../types/Policy';

interface Props {
  policy: Bundle;
  coverages: Coverage[];
}
const CoverageGrid: React.FC<Props> = ({ policy, coverages }) => {
  return (
    <div className={styles.grid}>
      {coverages.map((coverage) => (
        <CoverageGridCard
          policy={policy}
          coverage={coverage}
          key={coverage.scheduleURL}
          className={styles.coverageCard}
        />
      ))}
    </div>
  );
};

export { CoverageGrid };
